var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { open: true, "has-header": "", "has-footer": "" },
    on: { close: () => _vm.$emit("onCancel") },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h2", { staticClass: "emd-text _size_section" }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "_content-modal-success" }, [
              _c(
                "p",
                { staticClass: "eu-mt_3 eu-mb_3 _paragraph_color_success" },
                [_vm._v(" " + _vm._s(_vm.info) + " ")]
              ),
              _c("p", { staticClass: "emd-text _align_center" }, [
                _vm._v(" " + _vm._s(_vm.content) + " "),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "_content-modal-success" },
              [
                _c("emd-button", {
                  attrs: {
                    "data-testid": "button-success-reset-secret-key",
                    color: "success",
                    text: _vm.$t("submitButton"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onSubmit")
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }